export default "__VITE_ASSET__B$DX_fne__"